import React from 'react'
import './../index.css'

function footer() {
    return (
        <div className="footer-container">
        <h2>
            Developer : {" "}
            <a
            rel="noopener noreferrer"
            target="_blank"
            href="https://github.com/UmairShah90"
            >
            Umair Zafar

            </a>{" "}
        </h2>
        </div>
    )
}

export default footer;
